export const types = [
    {text: "小程序Banner", id: "17"}
  , {text:"小程序活动专区",id:"18"}
];
export const oldTypes = [
  {text: " -- 全部 -- ", id: ""}
  , {text: "首页中部左侧", id: "1"}
  , {text: "首页中部右上", id: "2"}
  , {text: "首页中部右下", id: "3"}
  , {text: "首页Banner", id: "6"}
  , {text: "缴费Banner", id: "7"}
  , {text: "首页中部Banner", id: "8"}
  , {text: "首页通栏广告", id: "9"}
  , {text: "员工APP广告", id: "10"}
  , {text: "首页限时预售", id: "11"}
  , {text: "我的中部广告", id: "13"}
  , {text: "我的底部广告", id: "14"}
  , {text: "首页底部广告幸福居", id: "15"}
  , {text: "精品专区", id: "16"}
  , {text: "小程序Banner", id: "17"}
  , {text:"小程序活动专区",id:"18"}
  , {text:"小嘉推荐",id:"19"}
  , {text:"嘉饰家顶部广告",id:"20"}
  , {text:"嘉饰家底部广告",id:"21"}
];

export const bagTypes = [
  {text: " -- 全部 -- ", id: ""}
  , {text: "首页中部左侧", id: "1"}
  , {text: "首页中部右上", id: "2"}
  , {text: "首页中部右下", id: "3"}
  , {text: "首页Banner", id: "6"}
  , {text: "缴费Banner", id: "7"}
  , {text: "首页中部Banner", id: "8"}
  , {text: "首页通栏广告", id: "9"}
]
export const ad_banner_list_filter = {
  methods: {
    typeFilter(o) {
      if (!o.type) return
      let result = types.filter(t => t.id == o.type)
      return result.length > 0 ? result[0].text : ''
    },
    dateStateFilter(o) {
      switch (o.dateState) {
        case '0':
          return '否'
        case '1':
          return '是'
        default:
          return
      }
    },
    flagFilter(o) {
      switch (o.flag) {
        case '0':
          return '禁用'
        case '1':
          return '启用'
        default:
          return
      }
    }
  }
}
export default {}
